import useIsUserAdmin from './useIsUserAdmin';
import { useGetMenuQuery } from '../redux/services/menu';

const useCheckIfUserCanSeePagesInMenu = () => {
  const { data: menuData, isLoading } = useGetMenuQuery();
  const isAdmin = useIsUserAdmin();

  return !isLoading && !isAdmin && menuData.length <= 0;
};

export default useCheckIfUserCanSeePagesInMenu;
